import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

const ConfirmDialog = ({
  setOpen,
  isLoading = false,
  open,
  handleDelete,
  name,
}) => {
  const handleClose = () => {
    setOpen({ open: false, data: null });
  };

  const handleConfirm = () => {
    handleDelete(open.data);
    // handleClose();
  };

  return (
    <Dialog open={open.open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{color:theme=>theme.palette.text.primary}}>Confirm the action</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose} sx={{color:theme=>theme.palette.text.primary}}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography sx={{color:theme=>theme.palette.text.primary}}>{name}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} className="glass-button-secondary-50" >
          Cancel
        </Button>
        <Button
          onClick={() => handleConfirm()}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={26} />
          ) : (
            "Confirm"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
